import { Controller } from "@hotwired/stimulus"

// copies the source target's value (or text) to the clipboard and flashes a "Copied" state on the button
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedLabel: { type: String, default: "Copied" } }

  async copy(event) {
    event.preventDefault()
    const source = this.sourceTarget
    const text = "value" in source ? source.value : source.textContent.trim()

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // clipboard api needs a secure context; fall back to selecting the text so the user can copy it
      if (source.select) source.select()
      return
    }

    this.buttonTarget.classList.add("copied")
    this.buttonTarget.setAttribute("aria-label", this.copiedLabelValue)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.buttonTarget.classList.remove("copied")
      this.buttonTarget.setAttribute("aria-label", "Copy")
    }, 1500)
  }
}
